import React, { Component } from "react";
import { Row, Col, Card, Button } from "antd";
import Category from "../../components/CategoriesCard";
import ShippingCost from "../../components/ShpingCost";
import CatalogCard from "../../components/catalogCard";
import { Store } from "../../store";
import { connect } from "react-redux";
import { CatalogAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import storePreview from "./storePreview";

import "./Styles.css";
class BuildCatalog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isClose: false,
      isOpenModal: false,
      filters: {
        order: "asc",
        page: 1,
        per_page: 12,
        column: "name",
        category_id: 1,
        // totalCount: 0,
        // currentCount: 0,
        // total_pages: 0,
        status: "active",
      },
      categoryName: "Standard Products",

      shipingprice: {
        am_charges: "0.0",
        pm_charges: "0.0",
      },
      price: "",
    };
  }

  abc = (key) => {
    this.setState({
      filters: {
        ...this.state.filters,
        category_id: key.id,
      },
      categoryName: key.name,
    });
  };

  componentDidMount() {
    const {
      getProducts,
      getCategories,
      getShippingCost,
      basemixdata,
      getbasemixes,
      getadditives,
      getbasemixesCategories,
    } = this.props;
    getProducts(this.state.filters, true);
    getCategories();
    getShippingCost();
    basemixdata();
    getbasemixes();
    getadditives();
    getbasemixesCategories();
  }

  componentDidUpdate(preProps, preState) {
    const { getProducts } = this.props;

    if (preProps.metaData !== this.props.metaData) {
      this.setState({
        filters: {
          ...this.state.filters,
          page: this.props?.metaData?.current_page,
          totalCount: this.props?.metaData?.total_records,
          currentCount: this.props?.metaData?.current_records,
          total_pages: this.props?.metaData?.total_pages,
        },
      });
    }

    if (
      preState.filters.category_id !== this.state.filters.category_id ||
      preState.filters.column !== this.state.filters.column ||
      preState.filters.per_page !== this.state.filters.per_page ||
      preState.filters.page !== this.state.filters.page
    ) {
      getProducts(this.state.filters, true);
    }
    if (preProps.shipingprice !== this.props.shipingprice) {
      this.setState({
        shipingprice: {
          am_charges: this.props?.shipingprice?.am_charges,
          pm_charges: this.props?.shipingprice?.pm_charges,
        },
      });
    }
  }

  currentPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page + 1,
      },
    });
  };
  previousPage = (e) => {
    this.setState({
      filters: {
        ...this.state.filters,
        page: this.state.filters?.page - 1,
      },
    });
  };

  onChangeShowingFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        per_page: value,
      },
    });
  };

  onUpdateShippingCost = (e, type) => {
    this.setState({
      shipingprice: {
        ...this.state.shipingprice,
        [type]: e,
      },
    });
  };

  onUpdatePrice = (price) => {
    this.setState({
      price: price,
    });
  };

  onChangeFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        column: value,
      },
    });
  };

  render() {
    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    return (
      <Row>
        <Col xl={24} lg={24} xs={24} sm={24} md={24}>
          <Card>
            <h6 className="text-left catalog-heading-register">
              Build Your Catalog
            </h6>
            <Row justify="space-between">
              <Col xl={6} lg={8} xs={24} sm={24} md={8}>
                <Category
                  abc={this.abc}
                  categorey={this.props.categories}
                  isImageTrue={true}
                  {...this.props}
                />
                <ShippingCost
                  onUpdateShippingCost={this.onUpdateShippingCost}
                  updateShippingCost={this.props.updateShippingCost}
                  value={this.state.shipingprice}
                  shipingprice={this.props.shipingprice}
                />
              </Col>
              <Col xl={18} md={16} lg={16}>
                <Row justify="start">
                  <Col xl={20} lg={24}>
                    <CatalogCard
                      {...this.props}
                      categoryName={this.state.categoryName}
                      onChangeFilter={this.onChangeFilter}
                      onChangeShowingFilter={this.onChangeShowingFilter}
                      metaData={this.state.filters}
                      currentPage={this.currentPage}
                      previousPage={this.previousPage}
                      updateProductPrice={this.props.updateProduct}
                      onUpdateProductPrice={this.onUpdatePrice}
                      value={this.state.price}
                      onOpenModal={(e) => this.setState({ price: e })}
                      fromNewCatalog={true}
                      NewCatalogInput={true}
                      postProduct={this.props.postProduct}
                      cardShow={true}
                      iscardTrue={true}
                      onAdd={this.props.onAdd}
                    />
                  </Col>
                </Row>
              </Col>
              <Col
                xl={24}
                xs={24}
                sm={24}
                md={24}
                lg={24}
              >
                <Row justify="end">
                  <Col xl={6} xs={12} sm={12} md={6} lg={5}>
                    <Button
                      style={{
                        backgroundColor: "#ff9800",
                        color: "#fff",
                        width: "50%",
                      }}
                      onClick={() => this.props.onChangePreview()}
                    >
                      PREVIEW
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    products: store.CatalogReducer.products,
    metaData: store.CatalogReducer.metaData,
    categories: store.CatalogReducer.categories,
    shipingprice: store.CatalogReducer.shipingprice,
    basemixData: store.CatalogReducer.basemixData,
    isLoadingCategory: store.CatalogReducer.isLoadingCategorey,
    isLoading: store.CatalogReducer.isLodading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active) =>
      dispatch(CatalogAction.updateProductReq(value, id, active)),
    postProduct: (payload) => dispatch(CatalogAction.postProductReq(payload)),
    basemixdata: (params) =>
      dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    getbasemixesCategories: (params) =>
      dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BuildCatalog);
